import React from "react";
import { formatDateAndHour } from "helpers/Parsers";
import styles from "./MainApp.organisms.Product.Table.TableItemMobile.module.scss";
import i18n from "i18n";

export class AuditTableItemMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imgError: false
    };
  }

  render() {
    const { audit, handleClick } = this.props;
    const { date, hour } = formatDateAndHour(audit.date);

    return (
      <div
        className={styles["table-item-mobile-container"]}
        onClick={() => handleClick(audit)}
      >
        <div className={styles["table-item-mobile-col-1"]}>
          <div className={styles["table-item-mobile-date"]}>{date}</div>
          <div className={styles["table-item-mobile-time"]}>{hour}</div>
        </div>

        <div className={styles["table-item-mobile-col-2"]}>
          <div className={styles["table-item-mobile-location"]}>
            {audit.path_name}
          </div>
          <div className={styles["table-item-mobile-user"]}>
            {audit.user_name}
          </div>
        </div>

        <div className={styles["table-item-mobile-col-3"]}>
          <div className={styles["table-item-mobile-status-pill"]}>
            <span
              className={`${styles["status-pill"]} ${
                audit.status ? styles["status-true"] : styles["status-false"]
              }`}
            >
              {audit.status ? i18n.t("complete") : i18n.t("incomplete")}
            </span>
          </div>
          <div className={styles["table-item-mobile-modified-pill"]}>
            <span
              className={`${styles["modified-pill"]} ${
                audit.modified
                  ? styles["modified-true"]
                  : styles["modified-false"]
              }`}
            >
              {audit.modified ? i18n.t("modified") : i18n.t("no.modified")}
            </span>
          </div>
          <div className={styles["table-item-mobile-chevron"]}>
            <i className="icon-chevron-right" />
          </div>
        </div>
      </div>
    );
  }
}

AuditTableItemMobile.propTypes = {};

export default AuditTableItemMobile;
